import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const token = localStorage.getItem('semsim_token');
    if (token) { authAPI.me().then(r => setUser(r.data)).catch(() => localStorage.removeItem('semsim_token')).finally(() => setLoading(false)); }
    else setLoading(false);
  }, []);
  const login = async (email, password) => {
    const { data } = await authAPI.login(email, password);
    localStorage.setItem('semsim_token', data.token);
    setUser(data.user); return data.user;
  };
  const logout = () => { localStorage.removeItem('semsim_token'); setUser(null); };
  return <AuthContext.Provider value={{ user, login, logout, loading }}>{children}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);
